<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M3.785 6.596l4.398-5.375C8.724.559 8.994.229 9.2.207a.5.5 0 01.454.2c.122.165.062.588-.059 1.433l-.367 2.574c-.059.407-.088.611-.056.776a1 1 0 00.655.755c.159.055.364.055.776.055 1.045 0 1.567 0 1.87.142a1.5 1.5 0 01.817 1.724c-.081.325-.412.729-1.074 1.538l-4.398 5.375c-.541.661-.811.992-1.016 1.014a.5.5 0 01-.454-.2c-.122-.165-.062-.588.059-1.433l.367-2.574c.059-.408.088-.611.056-.777a1 1 0 00-.655-.754C6.015 10 5.81 10 5.398 10c-1.045 0-1.568 0-1.87-.143a1.5 1.5 0 01-.817-1.723c.081-.325.412-.73 1.074-1.538z"
    fill="currentColor"
  />
</svg>
